export async function fetchTurbo(url, options = {}) {
  const token = document.head.querySelector('meta[name="csrf-token"]')?.content
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'text/vnd.turbo-stream.html'
  }

  if (token) {
    headers['X-CSRF-Token'] = token
  }

  const defaultOptions = {
    credentials: 'same-origin',
    headers
  }

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...(options.headers || {})
    }
  }

  return fetch(url, mergedOptions)
}
